import { PartnerOffersList as PartnerOffersListComponent } from './PartnerOffersList.component';
import { connector } from './PartnerOffersList.connector';

export const PartnerOffersList = connector(PartnerOffersListComponent);
